<template>
  <div class="container contenedor">
    <div class="">
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 left-panel">
        <!-- <a href="/">
          <div class="row logo">
            <img src="/static/img/logok.png" class="center-block logo" style="float: left; position: absolute;">
          </div>
        </a> -->
        <div class="row formulario" style="float: right;">
          <a href="/" style="display: flex; justify-content: center;">
            <div class="row logo">
              <img src="/static/img/logok.png" class="center-block logo">
            </div>
          </a>
          <div class="text-center loginForm">
            <!-- login form -->
            <form class="separador" style="display:flex; flex-direction: column; align-items: start;"  @submit.prevent="checkCreds">

              <div class="group">
                <input  name="username"  type="text" v-model="username" required>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Nombre de usuario</label>
              </div>
              <div class="group" style="margin-bottom: 15px;">
                <input  name="password"  type="password" v-model="password" required>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Clave del usuario</label>
              </div>
              <router-link to="/reestablecer">
                <span style="display: block;" data-cy="olvidaste">
                  <el-link type="primary" :underline="false" style="font-weight: bold; position: relative;">¿Olvidaste tu contraseña?</el-link>
                </span>
              </router-link>
              <div style="display: flex; justify-content: center; margin-top: 15px; width: 100%;">
                <button type="submit" v-bind:class="'btn btn-lg el-button--primary ' + loading">
                <i class="el-icon-loading" v-if="loadingGif"/>
                Iniciar sesión
                </button>
              </div>
            </form>

            <div v-if=response class="text-red"><p>{{response}}</p></div>
            <br>
            <div style="display:flex; width:50%; align-items: center; justify-content: center;" class="divider">
              <el-divider></el-divider>
              <p style="font-size: 18px; text-wrap:nowrap; margin: 0 10px 0 10px;">¿Primera vez que ingresás?</p>
              <el-divider></el-divider>
            </div>
            <!--<router-link v-if="!paramError" to="/solicitud">
              <h5>
                <el-link :underline="false">Solicitud de Usuario</el-link>
              </h5>
            </router-link>-->
              <div class="create-provider">
                <router-link v-if="this.availableCountries.length === 1" :to="'/userActivation'+this.availableCountries[0].codCountry">
                  <el-link :underline="false" class="create-provider_text" style="font-size: 18px;">
                    <el-link type="primary" class="create-provider_text">Darse de alta</el-link>
                  </el-link>
                </router-link>
               <el-link type="primary" class="create-provider_text" v-else v-on:click="flags = !flags">Darse de alta</el-link>
              </div>
            <div class="providerflags-container" v-if="flags === true">
               <div>
                <p v-if="this.availableCountries.length > 0" class="create-provider_subtitle">Seleccione en que país desea operar</p>
                <p v-else class="create-provider_subtitle" style="color: red;">No hay países disponibles para cargar proveedores</p>
               </div>
               <router-link v-for="country in availableCountries" :key="country.codCountry" :to="'/userActivation'+country.codCountry">
                  <el-link :underline="false">
                    <img class="flag" :src="'static/img/' + country.codCountry + '_Flag.png'"/>
                  </el-link>
               </router-link>
            </div>


            <h6 style="color:grey; margin-top:18px;">Operar con el Portal de Proveedores implica aceptar el <strong><el-link style="font-weight: bold; font-size: 1em;" type="primary" target="_blank" :href="configuration">
            Código de Conducta para Proveedores</el-link></strong></h6>

            <!-- errors -->
          </div>
        </div>
        <div v-if="entorno" class="entorno">{{entorno}}</div>
        </div>
      </div>


      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 right-panel login-image ">
        <div class="row mx-auto my-auto">
          <div style="margin-top: 50%;">
            <div class="titulo " style="background-color: RGB(0,0,0,.7); border-radius: 3px; padding: 30px;">
                  Bienvenido al <br> Portal de Compras y Proveedores</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Login',
  data (router) {
    return {
      section: 'Login',
      loading: '',
      loadingGif: false,
      username: '',
      password: '',
      response: '',
      paramError: null,
      paramErrorProv: null,
      configuration: '',
      flags: false,
      entorno: '',
      availableCountries: []
    }
  },
  mounted () {
    window.localStorage.removeItem('token')
  },
  methods: {
    getEticalCode () {
      api.request('get', 'api/findConfiguration/CODETI')
      .then(response => {
        this.configuration = response.data['value']
      })
      .catch(error => {
        console.log(error)
      })
    },
    getEntorno () {
      api.request('get', 'api/findConfiguration/ENTORNO')
      .then(response => {
        this.entorno = response.data['value']
      })
      .catch(error => {
        console.log(error)
      })
    },
    checkCreds () {
      this.loadingGif = true
      const username = this.username
      const password = this.password

      window.localStorage.removeItem('token')

      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      // We need to pass the component's this context
      // to properly make use of http in the auth service
      let that = this
      api.request('POST', 'api/login', {username, password}, false)
      .then(response => {
        this.loadingGif = false
        this.toggleLoading()

        var data = response.data
        /* Checking if error object was returned from the server */
        if (data.error) {
          var errorName = data.error
          console.log(errorName)
          if (errorName) {
            if (errorName === 'Usuario bloqueado') {
              that.$confirm('El usuario se encuentra bloqueado ¿Desea reestablecer su contraseña?', 'Atención', {
                confirmButtonText: 'Enviar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
              }).then(() => {
                that.$router.push('/reestablecer')
                .then(response => {
                })
              })
                .catch(error => {
                  console.log(error)
                })
            } else {
              that.response = errorName === 'InvalidCredentialsError'
              ? 'Usuario o clave incorrectos. Intente nuevamente.'
              : errorName
            }
          } else {
            that.response = data.error
          }

          return
        }

        /* Setting user in the state and caching record to the localStorage */
        if (data.user) {
          this.$store.commit('SET_USER', data.user)
          this.$store.commit('SET_TOKEN', data.token)

          if (window.localStorage) {
            this.$session.start()
            this.$session.set('jwt', data.token)

            window.localStorage.setItem('user', JSON.stringify(data.user))
            window.localStorage.setItem('token', data.token)
          }
          if (data.reqPsw === '2') {
            // this.$router.push(data.redirect ? data.redirect : '/changePsw')
            this.$router.push(data.redirect ? data.redirect : '/')
          } else {
            this.$router.push(data.redirect ? data.redirect : '/')
          }
        }
      })
      .catch(error => {
        this.$store.commit('TOGGLE_LOADING')
        console.log(error)

        this.response = 'Error al conectarse con el servidor, contacte al administrador.'
        this.toggleLoading()
        this.loadingGif = false
      })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
    }
  },
  beforeMount () {
    this.getEticalCode()
    this.getEntorno()
    api.request('get', 'api/checkParam?id=AP-001')
      .then(response => {
        var data = response.data
        console.log(data.error)
        if (data.error) {
          this.paramErrorProv = data.error
        }
      })
      .catch(error => {
        console.log(error)
      })
    api.request('get', 'api/checkParam?id=SUN-001')
      .then(response => {
        var data = response.data
        console.log('SUN-001', data)
        this.availableCountries = data
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style>
* {
  margin:  0;
  padding: 0;
}
@media (max-width: 990px) {
    .login-image {
      display: none;
    }
  }
html, body, .container-table {
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
}
h4 {
  font-size: 24px;
  font-weight: 300;
  letter-spacing: .4px;
  color: rgba(21, 28, 41, .48);
  padding: 15px 0 5px;
  margin: 5px 0;
}
h5 {
  font-size: 11px;
  font-weight: 300;
  letter-spacing: .4px;
  color: rgba(21, 28, 41, .48);
  padding: 15px 0 5px;
  margin: 5px 0;
}

.mensaje h4 {
  color: #fff;
  position: inherit;
  font-size: 24px;
  letter-spacing: 3.4px;
  top: -114px;
  line-height: 36px;
}
.container-table {
    display: table;
    color: white;
}
.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.logo {
  padding: 1em;
  max-width: 300px;
  width: 20vw;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}
.input-group input {
  height: 4em;
}

.formulario{
  float: left;
  width: 100%;
  text-align: center;
  margin-top: 10vh;
  margin-left: 0;
  margin-right: 0;
}
.contenedor{
  height: 100vh;
  width: 100%;
  margin:  0;
  padding: 0;
}
.left-panel{
  min-height: 100vh;
}
.right-panel {
  background-image: url('/static/img/iproveedoresFront.jpg');
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 150vh;
}
.circle{
  border-radius: 45px;
}
.titulo{
  text-align: center;
  color: white;
  font-size: 24px;
  text-shadow: 2px 2px rgba(21,28,41,.48);
  width: 100%;
  padding: 0 15px;
  display: block;
  margin-block-start: 1.33em;
  margin-block-end: 1.33em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.right-buttons{
  padding-top: 40vh;
}
.left-buttons{
  padding-top: 20vh;
}
.left-button{
  background-color:rgba(0,0,0,.2);
}
.text-butons{
  font-size: 12px;
  color: #2C0072;
}
.opaco{
  background-color:rgba(255,255,255,.5);
}
.separador{
  position: relative;
  padding-top: 8vh;
}
/*----------PAPER-----------*/
/* form starting stylings ------------------------------- */
.group {
  width: 30vw;
  position:relative;
  margin-bottom:45px;
}

.create-provider {
  font-size:18px;
  margin: 5px 0;
  display: flex;
  justify-content: center;
}
.create-provider_text {
  cursor:pointer;
  user-select: none;
  font-weight: 600 !important;
  font-size: 17px !important;
}
.create-provider_subtitle{
  margin-top: 3px;
  font-size:14px;
}
.flag{
  cursor:pointer;
  margin: 10px;
  margin-bottom: 2px;
}

input         {
  font-size:18px;
  padding:10px 10px 10px 5px;
  display:block;
  width: 100%;
  border:none;
  border-bottom:1px solid #757575;
}
input:focus     { outline:none; }

/* LABEL ======================================= */
label          {
  color:#999;
  font-size:18px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}

/* active state */
input:focus ~ label, input:valid ~ label    {
  top:-20px;
  font-size:14px;
  color:#5264AE;
}

/* BOTTOM BARS ================================= */
.bar  { position:relative; display:block; width:100%; }
.bar:before, .bar:after   {
  content:'';
  height:2px;
  width:0;
  bottom:1px;
  position:absolute;
  background:#5264AE;
  transition:0.2s ease all;
  -moz-transition:0.2s ease all;
  -webkit-transition:0.2s ease all;
}
.bar:before {
  left:50%;
}
.bar:after {
  right:50%;
}

/* active state */
input:focus ~ .bar:before, input:focus ~ .bar:after {
  width:50%;
}

/* HIGHLIGHTER ================================== */
.highlight {
  position:absolute;
  height:60%;
  width:100px;
  top:25%;
  left:0;
  pointer-events:none;
  opacity:0.5;
}

/* active state */
input:focus ~ .highlight {
  -webkit-animation:inputHighlighter 0.3s ease;
  -moz-animation:inputHighlighter 0.3s ease;
  animation:inputHighlighter 0.3s ease;
}

.text-butons {
    font-size: 12px;
}

/* ANIMATIONS ================ */
@-webkit-keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}
@-moz-keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}
@keyframes inputHighlighter {
  from { background:#5264AE; }
  to  { width:0; background:transparent; }
}
.entorno {
  position: fixed;
  top: 93%;
  left: 85%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.7);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: blue;
  z-index: 1;
}
.loginForm{
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.btnAltaProv button{
  padding: 10rem;
}
.divider>.el-divider{
 background-color:rgba(0, 0, 0, 0.5);
}
/* media queries */
@media screen and (max-width: 992px) {
  .group{
    width: 50vw;
  }
  .logo{
    width: 230px;
  }
}

@media screen and (max-width: 640px){
  .group{
    width: 70vw;
  }
  .logo{
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?1dae5f36